/* eslint-disable */
/* tslint:disable */
import PropTypes from 'prop-types';
import React from 'react';
var comments = function (_a) {
    var size = _a.size, className = _a.className;
    return (React.createElement("svg", { className: className, width: "14px", height: "14px", viewBox: "0 0 14 14", version: "1.1", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("title", null, "90EE158C-3A34-41AF-9416-06F2471C6355@1x"),
        React.createElement("g", { id: "collections", stroke: "none", "stroke-width": "1", fill: "param(fill)", "fill-rule": "evenodd" },
            React.createElement("g", { id: "Select-Media---commented", transform: "translate(-311.000000, -377.000000)", fill: "", "fill-rule": "nonzero" },
                React.createElement("g", { id: "2", transform: "translate(296.000000, 229.000000)" },
                    React.createElement("g", { id: "comment-shaddow", transform: "translate(8.000000, 143.000000)" },
                        React.createElement("g", { id: "comment-shaddow", transform: "translate(7.000000, 4.000000)" },
                            React.createElement("g", { id: "Rectangle-Copy", transform: "translate(0.000000, 1.000000)" },
                                React.createElement("path", { d: "M14,0 L14,10 L8.76153564,10 L4,14 L4,10 L0,10 L0,0 L14,0 Z M13,1 L1,1 L1,9 L5,9 L5,11.853 L8.39724472,9 L13,9 L13,1 Z" })))))))));
};
comments.displayName = 'love_empty';
comments.propTypes = {
    size: PropTypes.string
};
export default comments;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=comments.js.map